export enum GroupType {
    AND = "*and*", 
    OR = "*or*"
  }